import React from 'react';

import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

import Theme from '@adsk/alloy-react-theme';

const Container = styled.div`
  position: relative;
  height: 320px;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow-y: auto;
  border: 1px dashed ${Theme.colors.charcoal400};
  border-radius: 6px;
  ${({ dragged, disabled, error }) => {
    if (dragged && !disabled) {
      return `
        background-color: ${Theme.colors.adskBlue100};
        border: none;
      `;
    } else if (error && !disabled) {
      return `
        background-color: ${Theme.colors.red300};
        border: none;
      `;
    }
    return '';
  }}}
`;

const DropZone = React.forwardRef(({ children, disabled, onDrop }, ref) => {
  const { isDragActive, isDragReject, getRootProps, getInputProps } =
    useDropzone({
      disabled,
      noClick: true,
      noDragEventsBubbling: true,
      onDrop,
    });

  return (
    <Container
      ref={ref}
      disabled={disabled}
      dragged={isDragActive}
      error={isDragReject}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {children}
    </Container>
  );
});

DropZone.displayName = 'DropZone';
DropZone.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onDrop: PropTypes.func,
};

export default DropZone;
